import { membersNumber } from 'config/constants/constants';
import { socialLinks } from '../constants/socialLinks';

export const career = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Boldare',
  url: 'https://www.boldare.com/career/',
  description: `Boldare is a digital product design and development company with ${membersNumber}+ creative professionals working across Europe in cities including Gliwice, Kraków, Wrocław, and Warszawa. They deliver world-class software and design solutions to international clients.`,
  location: [
    {
      '@type': 'Place',
      name: 'Gliwice Office',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Gliwice',
        addressCountry: 'PL',
      },
    },
    {
      '@type': 'Place',
      name: 'Kraków Office',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Kraków',
        addressCountry: 'PL',
      },
    },
    {
      '@type': 'Place',
      name: 'Wrocław Office',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Wrocław',
        addressCountry: 'PL',
      },
    },
    {
      '@type': 'Place',
      name: 'Warszawa Office',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Warszawa',
        addressCountry: 'PL',
      },
    },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Career Opportunities and Talent Pool',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Talent Pool Membership',
          description:
            'Join the Boldare Talent Pool to get priority for job offers and stay informed about recruitment processes.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Job Opportunities',
          description: `Work with a team of ${membersNumber}+ specialists on digital product development for international clients.`,
        },
      },
    ],
  },
  sameAs: Object.values(socialLinks),
};
